import { SecurityProfile } from './api';

export const SMS_PATH = '/sms-verification';
export const PASSWORD_PATH = '/personal/changePassword';
export function requiredSecurityPath(profile: SecurityProfile, smsVerified: boolean) {
  if (profile.smsCaptchaEnabled && !smsVerified) return SMS_PATH;
  if (profile.pwdNeedChange) return PASSWORD_PATH;
  return null;
}
